import { render, staticRenderFns } from "./remove_smart_insertion.vue?vue&type=template&id=7b2ee389&scoped=true"
import script from "./remove_smart_insertion.vue?vue&type=script&lang=js"
export * from "./remove_smart_insertion.vue?vue&type=script&lang=js"
import style0 from "./remove_smart_insertion.vue?vue&type=style&index=0&id=7b2ee389&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ee389",
  null
  
)

export default component.exports